import React, { useState } from "react";
import {
  Container,
  Header,
  FormField,
  Textarea,
  ColumnLayout,
  FileDropzone,
  Box,
  FileInput,
  SpaceBetween,
  Badge,
  Checkbox,
  CheckboxProps,
} from "@amzn/awsui-components-react/polaris";
import { useBusinessIdsFileUploader } from "hooks/useFileProcessor";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-react";

interface BusinessUploadStepProps {
  businessIds: string;
  nonManagedUseCaseConfirmed: boolean;
  validationError: string;
  confirmationValidationError: string;
  handleBusinessIdsChanged: (event: { detail: { value: string } }) => void;
  handleNonManagedbusinessConfirmationCheckChange: (
    event: NonCancelableCustomEvent<CheckboxProps.ChangeDetail>
  ) => void;
  getBusinessIdList: () => string[];
  onBusinessIdsLoaded: (businessIds: string[]) => void;
  onError: (error: string) => void;
}

export const BusinessUploadStep: React.FC<BusinessUploadStepProps> = ({
  businessIds,
  validationError,
  confirmationValidationError,
  handleBusinessIdsChanged,
  nonManagedUseCaseConfirmed,
  handleNonManagedbusinessConfirmationCheckChange,
  getBusinessIdList,
  onBusinessIdsLoaded,
  onError,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const { handleFileUpload } = useBusinessIdsFileUploader({
    onBusinessIdsLoaded,
    onError,
    onFilesChanged: setUploadedFiles,
  });
  return (
    <Container>
      <SpaceBetween direction="vertical" size="l">
        <Header variant="h3">Upload Businesses</Header>
        <FormField errorText={confirmationValidationError} stretch>
          <Checkbox checked={nonManagedUseCaseConfirmed} onChange={handleNonManagedbusinessConfirmationCheckChange}>
            I confirm those businesses are not public sector (B2G), they dont have FACe or compliance needs protected by
            the IBA Managed use case.{" "}
            <a
              href="https://w.amazon.com/bin/view/B2B/IBA/OE/Runbooks/ProgramEnablement#HForIBA-Developers"
              target={"_blank"}
              rel="noreferrer"
            >
              See more
            </a>
          </Checkbox>
        </FormField>
        <FormField errorText={validationError} stretch>
          <Textarea
            value={businessIds}
            onChange={handleBusinessIdsChanged}
            placeholder="Enter Business IDs (new lines or comma-separated)"
            autoFocus
          />
        </FormField>
        <ColumnLayout columns={1} variant="text-grid">
          <div>
            <SpaceBetween direction="vertical" size="m">
              <Header variant="h3">Or upload a file</Header>
              <FileDropzone onChange={handleFileUpload}>
                <SpaceBetween size="s" alignItems="center" direction="vertical">
                  <Box textAlign="center">
                    <SpaceBetween size="xxs" direction="vertical">
                      <Box variant="strong">Drop your file here or</Box>
                      <FileInput value={uploadedFiles} onChange={handleFileUpload} accept=".csv,.txt,.xlsx">
                        Choose file
                      </FileInput>
                      <Box color="text-body-secondary" fontSize="body-s">
                        (.CSV, .TXT, or .XLSX supported only)
                      </Box>
                    </SpaceBetween>
                  </Box>
                </SpaceBetween>
              </FileDropzone>
            </SpaceBetween>
          </div>
        </ColumnLayout>
        <Container>
          <SpaceBetween direction="horizontal" size="xs" alignItems="center">
            <Badge color="blue">{getBusinessIdList().length}</Badge>
            <Box variant="strong">Business IDs added</Box>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    </Container>
  );
};
